import { ToolsMenuItemSlotPlacement as BasicToolsMenuItemSlotPlacement } from '@wix/extensions-slots-host';
import { withEditorSlotsState } from '../withEditorSlotsState';

export const ToolsMenuItemSlotPlacement = withEditorSlotsState(
  BasicToolsMenuItemSlotPlacement,
);
